import { render, staticRenderFns } from "./projectDialog.vue?vue&type=template&id=3c5c62fa&"
import script from "./projectDialog.vue?vue&type=script&lang=js&"
export * from "./projectDialog.vue?vue&type=script&lang=js&"
import style0 from "./projectDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports